/** The TanStack Query keys of the control API's resources. */
export const queryKeys = {
  me: () => ['me'] as const,
  all: ['simulation'] as const,
  status: () => [...queryKeys.all, 'status'] as const,
  /** Every query about the stored chargers: their pages, one charger, the template, an import preview. */
  chargers: () => [...queryKeys.all, 'chargers'] as const,
  /** Every page of the stored chargers, whatever the search, the state and the page. */
  chargerPages: () => [...queryKeys.chargers(), 'page'] as const,
  chargerPage: (query: { search: string; state: string | undefined; page: number }) =>
    [...queryKeys.chargerPages(), query.search, query.state ?? 'ALL', query.page] as const,
  charger: (chargeBoxId: string) => [...queryKeys.chargers(), 'one', chargeBoxId] as const,
  template: () => [...queryKeys.chargers(), 'template'] as const,
  /** A running charger as it is now (its Live tab). */
  chargerLive: (chargeBoxId: string) => [...queryKeys.chargers(), 'live', chargeBoxId] as const,
  /** A running charger's last OCPP messages, gathered poll by poll (its Live tab). */
  chargerMessages: (chargeBoxId: string) => [...queryKeys.chargers(), 'messages', chargeBoxId] as const,
};
